document.addEventListener('DOMContentLoaded', () => {
    const openMenu = document.getElementById('open-menu');
    const dropdown = document.getElementById('dropdown');
    // Solo LIs y anchors de primer nivel del menú (evita sub-items)
    const menuItems = dropdown ? dropdown.querySelectorAll('.dropdown-content > li') : [];
    const topLevelAnchors = dropdown ? dropdown.querySelectorAll('.dropdown-content > li > a') : [];
    // Soporte para múltiples botones de regreso
    const backButtons = document.querySelectorAll('.back');
    // Botones de cierre total
    const closeButtons = document.querySelectorAll('.close');

    // Debug opcional (puedes eliminar luego)
    // console.log({ openMenu, dropdown, back, menuLinks: menuLinks.length });

    // Scroll lock helpers
    let lastScrollY = 0;
    function lockScroll() {
        if (document.body.classList.contains('scroll-locked')) return;
        document.body.classList.add('scroll-locked');
    }
    function unlockScroll() {
        if (!document.body.classList.contains('scroll-locked')) return;
        document.body.classList.remove('scroll-locked');
    }

    if (openMenu && dropdown) {
        openMenu.addEventListener('click', () => {
            const isOpening = !dropdown.classList.contains('open');
            dropdown.classList.toggle('open');
            openMenu.classList.toggle('active');
            openMenu.setAttribute('aria-expanded', String(isOpening));
            if (isOpening) {
                lockScroll();
                // Abrir automáticamente el primer acordeón
                const firstAccordion = dropdown.querySelector('.dropdown-content > li.has-accordion');
                if (firstAccordion) {
                    firstAccordion.classList.add('accordion-open');
                }
            } else {
                unlockScroll();
            }
        });
    }

    // Solo un <li> con 'open' a la vez
    // Togglear solo cuando se hace click en el anchor de primer nivel con submenú
    topLevelAnchors.forEach(a => {
        a.addEventListener('click', (e) => {
            const anchor = a;
            const li = anchor.closest('li');
            if (!li) return;
            const hasSubmenu = !!li.querySelector('.sub-menu');
            const hasAccordion = li.classList.contains('has-accordion');

            // Si tiene accordion: evitar navegación y togglear accordion
            if (hasAccordion) {
                e.preventDefault();
                e.stopPropagation();
                // Alternar el accordion
                li.classList.toggle('accordion-open');
                return;
            }

            // Si tiene submenú: evitar navegación y togglear
            if (hasSubmenu) {
                e.preventDefault();
                e.stopPropagation();
                // Cerrar otros
                menuItems.forEach(item => { if (item !== li) item.classList.remove('open'); });
                // Alternar el actual
                li.classList.toggle('open');
                return;
            }
            // Si NO tiene submenú, permitir navegación sin tocar clases
        });
    });

    // Permitir abrir submenú al clickear en el área del <li> (whitespace/íconos),
    // pero ignorando clicks dentro del submenú o en enlaces reales
    menuItems.forEach(li => {
        li.addEventListener('click', (e) => {
            const target = e.target instanceof HTMLElement ? e.target : null;
            if (!target) return;

            // No reaccionar si el click fue dentro del submenú o en back/close
            if (target.closest('.sub-menu') || target.closest('.back') || target.closest('.close')) return;

            // No reaccionar si el click fue dentro del accordion-content
            if (target.closest('.accordion-content')) return;

            const hasSubmenu = !!li.querySelector('.sub-menu');
            const hasAccordion = li.classList.contains('has-accordion');

            // Si tiene accordion, togglear accordion
            if (hasAccordion) {
                e.preventDefault();
                li.classList.toggle('accordion-open');
                return;
            }

            if (!hasSubmenu) return; // elementos sin submenú no togglean aquí

            // Si el click fue en un anchor con href real, deja navegar
            const anchor = target.closest('a[href]');
            if (anchor) {
                const href = anchor.getAttribute('href') || '';
                if (href && href !== '#') return;
            }

            // Cerrar otros y togglear este
            e.preventDefault();
            menuItems.forEach(item => { if (item !== li) item.classList.remove('open'); });
            li.classList.toggle('open');
        });
    });

    // Evita que clicks dentro del submenú disparen toggles del padre
    const subMenus = dropdown ? dropdown.querySelectorAll('.sub-menu') : [];
    subMenus.forEach(sm => {
        sm.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });

    // Botón back: cierra todos los abiertos y opcionalmente cierra el dropdown
    if (backButtons.length) {
        backButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const parentLi = btn.closest('li.open');
                if (parentLi) parentLi.classList.remove('open');
            });
        });
    }

    // Cerrar completamente el menú y resetear submenús
    if (closeButtons.length) {
        closeButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                // 1) Cerrar submenú abierto (slide lateral)
                const openLi = dropdown ? dropdown.querySelector('.dropdown-content > li.open') : null;
                const subMenu = openLi ? openLi.querySelector('.sub-menu') : null;

                if (openLi && subMenu instanceof HTMLElement) {
                    // Quitar la clase para disparar la transición hacia el lado
                    openLi.classList.remove('open');

                    const finish = () => {
                        // 2) Cerrar el dropdown principal (slide hacia arriba)
                        if (dropdown) dropdown.classList.remove('open');
                        if (openMenu) {
                            openMenu.classList.remove('active');
                            openMenu.setAttribute('aria-expanded', 'false');
                        }
                        unlockScroll();
                        // Asegurar reset de cualquier li
                        menuItems.forEach(l => l.classList.remove('open'));
                    };

                    /** @param {TransitionEvent} ev */
                    const onEnd = (ev) => {
                        if (ev.propertyName !== 'transform') return; // aseguramos que viene de la transición lateral
                        subMenu.removeEventListener('transitionend', onEnd);
                        finish();
                    };

                    // Escuchar el final de la transición; usar once para evitar leaks
                    subMenu.addEventListener('transitionend', onEnd, { once: true });

                    // Fallback por si transitionend no dispara (por display: none, etc.)
                    setTimeout(() => {
                        // Si aún está abierto el dropdown, ciérralo
                        if (dropdown && dropdown.classList.contains('open')) {
                            finish();
                        }
                    }, 550); // ligeramente mayor que 0.5s

                    return;
                }

                // Si no hay submenú abierto, cerrar inmediatamente el dropdown
                menuItems.forEach(l => l.classList.remove('open'));
                if (dropdown) dropdown.classList.remove('open');
                if (openMenu) {
                    openMenu.classList.remove('active');
                    openMenu.setAttribute('aria-expanded', 'false');
                }
                unlockScroll();
            });
        });
    }

    // Desktop mega menu: the submenu opens on hover / keyboard focus (CSS),
    // so mirror that state on the top-level link for assistive tech
    const megaMenuItems = [];
    document.querySelectorAll('.ctn_header--desktop .links > li').forEach(li => {
        const trigger = li.querySelector(':scope > a[aria-controls]');
        if (!trigger) return;
        megaMenuItems.push(li);
        const setExpanded = (expanded) => trigger.setAttribute('aria-expanded', String(expanded));
        li.addEventListener('mouseenter', () => setExpanded(true));
        li.addEventListener('mouseleave', () => {
            li.classList.remove('is-dismissed');
            setExpanded(li.contains(document.activeElement) && li.matches(':has(:focus-visible)'));
        });
        li.addEventListener('focusin', () => setExpanded(!li.classList.contains('is-dismissed') && (li.matches(':has(:focus-visible)') || li.matches(':hover'))));
        li.addEventListener('focusout', (e) => {
            if (li.contains(e.relatedTarget)) return;
            li.classList.remove('is-dismissed');
            setExpanded(li.matches(':hover'));
        });
    });

    // Escape dismisses an open submenu (WCAG 1.4.13) until the pointer or focus leaves it
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        megaMenuItems.forEach(li => {
            const trigger = li.querySelector(':scope > a[aria-controls]');
            if (trigger.getAttribute('aria-expanded') !== 'true') return;
            li.classList.add('is-dismissed');
            trigger.setAttribute('aria-expanded', 'false');
            if (li.contains(document.activeElement) && document.activeElement !== trigger) trigger.focus();
        });
    });

    // --- CART ICON REAL-TIME UPDATE ---
    function setHidden(el, hide) {
        if (!el) return;
        if (hide) {
            el.setAttribute('hidden', '');
            el.setAttribute('aria-hidden', 'true');
            el.classList.add('is-hidden');
            el.style.display = 'none';
        } else {
            el.removeAttribute('hidden');
            el.setAttribute('aria-hidden', 'false');
            el.classList.remove('is-hidden');
            el.style.display = '';
        }
    }

    // Clase temporal para animar el icono del carrito
    function pulseCartShake() {
        document.querySelectorAll('a.cart').forEach(el => {
            el.classList.remove('is-shaking'); // reinicia la animación si ya estaba
            // fuerza reflow para reiniciar animación
            // eslint-disable-next-line no-unused-expressions
            el.offsetWidth;
            el.classList.add('is-shaking');
            setTimeout(() => el.classList.remove('is-shaking'), 800);
        });
    }

    // Llevar el estado previo de items del carrito para detectar incrementos
    let lastCartCount = null;

    function updateCartIcon() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                const count = cart.item_count;

                // Actualiza contadores
                document.querySelectorAll('.js-cart-count').forEach(cc => {
                    cc.textContent = count;
                    setHidden(cc, count <= 0);
                });

                // Mantener el nombre accesible del enlace del carrito al día
                document.querySelectorAll('a.cart[data-cart-label]').forEach(link => {
                    link.setAttribute('aria-label', `${link.dataset.cartLabel}: ${count}`);
                });

                // Muestra/oculta íconos
                document.querySelectorAll('.js-cart-icon').forEach(wrapper => {
                    const filled = wrapper.querySelector('.js-cart-icon-filled');
                    const empty = wrapper.querySelector('.js-cart-icon-empty');
                    setHidden(filled, count <= 0);
                    setHidden(empty, count > 0);
                });
            })
            .catch(() => { /* noop */ });
    }

    // Estado inicial
    updateCartIcon();

    // Escucha eventos comunes
    document.body.addEventListener('ajaxCart:afterAdd', () => {
        updateCartIcon();
        pulseCartShake(); // asegura animación incluso sin comparar conteos
    });
    document.body.addEventListener('cart:refresh', updateCartIcon);
    document.body.addEventListener('cart:updated', updateCartIcon);

    // Fallback: polling si tu tema no dispara eventos
    setInterval(() => {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                if (cart.item_count !== lastCartCount) {
                    updateCartIcon(); // internamente decide si anima
                }
            })
            .catch(() => { /* noop */ });
    }, 2000);
});